import { Payment } from '@vsolv/packages/payments/domain';

/** Staff-only presentation of the credential-free payment gateway view. */
export function paymentGatewayName(gateway: Payment.GatewayView | undefined): string {
  if (gateway?.assignmentState === 'legacy') return 'Legacy gateway — instance not recorded';
  if (gateway?.assignmentState !== 'assigned') return 'Gateway unknown — not recorded';
  return gateway.displayName ?? 'Gateway metadata unavailable';
}

export function paymentGatewayProvider(gateway: Payment.GatewayView | undefined): string | null {
  if (!gateway?.provider) return null;
  return gateway.provider === 'AUTHORIZE_NET' ? 'Authorize.Net' : gateway.provider;
}

export function paymentGatewayProvenance(gateway: Payment.GatewayView | undefined): string | null {
  if (gateway?.labelSource === 'current_instance') return 'Current label; historical label not recorded';
  if (gateway?.assignmentState === 'assigned' && gateway.labelSource === 'unavailable') {
    return 'Historical gateway metadata unavailable';
  }
  return null;
}

export function paymentGatewaySubtitle(gateway: Payment.GatewayView | undefined): string {
  return [gateway?.instanceId, paymentGatewayProvenance(gateway)].filter(Boolean).join(' · ');
}
